// Modules
import React from "react";
import PropTypes from "prop-types";

const LogoPrimary = (props) => {
	const { clssName } = props;

	return (
		<svg
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			x="0px"
			y="0px"
			viewBox="0 0 1366 440"
			className={clssName}
		>
			<g>
				<g>
					<path d="M178.45,227.25c0-11.6,1.28-19.3,3.85-23.1c2.56-3.79,8.2-5.69,16.91-5.69c11.6,0,19.97,4.18,25.11,12.55
			c5.13,8.37,7.7,20.81,7.7,37.33c0,9.6-1.12,18.58-3.35,26.95c-2.23,8.37-6.14,15.06-11.72,20.09c-5.58,5.02-13.62,7.53-24.11,7.53
			h-14.4V227.25z M178.45,308.6h14.06c19.86,0,34.09,4.68,42.69,14.06c8.6,9.38,12.89,22.65,12.89,39.84
			c0,18.75-3.74,33.2-11.21,43.35c-7.48,10.16-19.26,15.23-35.32,15.23c-9.59,0-15.85-1.72-18.75-5.19
			c-2.9-3.45-4.35-10.99-4.35-22.59V308.6z M354.83,430.06h0.01c0-0.01-0.01-0.01-0.01-0.01V430.06z M180.9,6.24L0.22,156.33v271.74
			h115.69c2.14-0.06,4.39-0.1,6.8-0.13c9.48-0.1,19.13-0.16,28.95-0.16c14.07,0,26.16,0.16,36.33,0.49
			c10.14,0.35,17.9,0.51,23.26,0.51c28.79,0,51.39-5.58,67.8-16.73c16.4-11.17,24.6-27.23,24.6-48.21c0-9.16-2.67-17.97-8.03-26.45
			c-5.36-8.48-14.17-15.73-26.45-21.76c-12.28-6.04-28.91-9.82-49.88-11.38v-0.68c15.63-2.89,28.34-7.47,38.17-13.72
			c9.82-6.24,17.08-13.39,21.76-21.42c4.7-8.03,7.04-15.95,7.04-23.76c0-15.4-6.86-28.01-20.59-37.84
			c-13.72-9.81-34.43-14.72-62.11-14.72c-4.23,0-11.38,0.12-21.42,0.33c-10.04,0.22-20.41,0.33-31.13,0.33
			c-9.38,0-18.81-0.12-28.29-0.33c-9.49-0.22-17.02-0.45-22.59-0.68v6.7c6.91,0.23,12.21,1.05,15.89,2.51
			c3.68,1.44,6.14,4.13,7.37,8.03c1.23,3.9,1.85,9.98,1.85,18.25V393.3c0,8.03-0.62,14.06-1.85,18.07c-1.23,4.02-3.63,6.7-7.19,8.03
			c-1,0.38-2.14,1.01-5.01,1.01H9.74V160.79L180.96,18.58l173.86,142.24v94.61c2.95-2.5,6.15-4.67,9.52-6.63v-92.49L180.9,6.24z"/>
					<path d="M442.09,399.75c-7.93,3.35-15.23,5.02-21.93,5.02c-6.92,0-13.73-2.18-20.42-6.53c-6.69-4.35-12.22-11.33-16.57-20.92
			c-4.35-9.59-6.53-22.1-6.53-37.49c0-3.12,0.05-6.14,0.17-9.04c0.09-2.32,0.24-4.52,0.4-6.69h93.84c0-26.33-5.58-45.3-16.74-56.91
			c-11.16-11.6-26.56-17.41-46.2-17.41c-15.85,0-29.96,3.41-42.35,10.21c-0.49,0.27-0.94,0.59-1.42,0.87
			c-3.36,1.96-6.56,4.14-9.52,6.63c0,0,0,0,0,0c-7.32,6.18-13.38,14-18.19,23.46c-7.03,13.84-10.55,31.13-10.55,51.89
			c0,20.31,3.29,37.05,9.88,50.22c4.89,9.79,11.18,17.73,18.86,23.82c2.65,2.1,5.45,3.99,8.43,5.64c0.36,0.2,0.73,0.37,1.09,0.56
			c11.35,6.08,24.37,9.15,39.08,9.15c12.5,0,23.21-2.57,32.14-7.7c8.92-5.13,16.29-11.72,22.1-19.75
			c5.8-8.04,10.04-16.29,12.72-24.77l-6.03-2.01C457.43,389.16,450.01,396.41,442.09,399.75z M386.18,271.54
			c5.47-9.82,12.1-14.73,19.92-14.73c5.58,0,10.04,2.79,13.39,8.37c3.35,5.58,5.8,13,7.36,22.26c1.56,9.26,2.23,19.36,2.01,30.3
			h-52.39C377.71,296.4,380.93,280.96,386.18,271.54z"/>
				</g>
				<path d="M637.1,256.22c-4.91,0.22-9.6,0.33-14.06,0.33c-4.47,0-9.66-0.11-15.57-0.33c-5.92-0.22-11.44-0.44-16.57-0.67v6.69
		c10.49,0.9,17.85,5.52,22.1,13.89c4.24,8.37,3.23,21.59-3.01,39.67l-23.95,66.38l-38.32-101.54c-1.79-6.25-2.01-10.6-0.67-13.06
		c1.34-2.45,3.85-3.9,7.53-4.35c3.68-0.44,7.87-0.67,12.55-0.67v-7.03c-6.7,0.45-13.89,0.84-21.59,1.17
		c-7.7,0.33-15.01,0.5-21.93,0.5c-9.16,0-17.58-0.17-25.28-0.5s-15.12-0.72-22.26-1.17v7.03c2.46,0,5.41,0.95,8.87,2.85
		c3.46,1.9,6.97,7.2,10.55,15.9l59.59,147.97c3.57-0.22,7.2-0.33,10.88-0.33c3.68,0,7.31,0.11,10.88,0.33l48.88-138.26
		c3.57-9.82,7.25-16.79,11.05-20.92c3.79-4.13,7.81-6.75,12.05-7.87v-6.69C645.91,255.77,642,256,637.1,256.22z"/>
				<path d="M738.53,250.86c16.29,0,30.58,3.01,42.85,9.04c12.27,6.03,21.87,15.73,28.79,29.12c6.91,13.39,10.38,31.13,10.38,53.23
		c0,22.1-3.46,39.79-10.38,53.06c-6.92,13.28-16.52,22.93-28.79,28.96c-12.28,6.03-26.56,9.04-42.85,9.04
		c-15.85,0-29.96-3.01-42.35-9.04c-12.39-6.03-22.1-15.68-29.12-28.96c-7.03-13.28-10.54-30.97-10.54-53.06
		c0-22.09,3.51-39.84,10.54-53.23c7.03-13.39,16.74-23.1,29.12-29.12C708.57,253.87,722.68,250.86,738.53,250.86z M738.53,257.55
		c-8.93,0-16.4,6.64-22.43,19.92c-6.03,13.28-9.04,34.87-9.04,64.78c0,29.91,3.01,51.45,9.04,64.61
		c6.03,13.17,13.5,19.75,22.43,19.75c9.15,0,16.68-6.58,22.6-19.75c5.91-13.16,8.87-34.7,8.87-64.61c0-29.9-2.96-51.5-8.87-64.78
		C755.21,264.2,747.68,257.55,738.53,257.55z"/>
				<path d="M1008.02,251.86v140.27c0,10.04,1.56,17.47,4.69,22.26c3.12,4.8,8.7,7.2,16.74,7.2v7.03c-6.92-0.67-13.84-1-20.76-1
		c-9.37,0-18.08,0.33-26.11,1c-8.03,0.67-15.62,1.89-22.76,3.68v-30.13c-5.36,11.16-12.78,19.14-22.26,23.94
		c-9.49,4.8-20.03,7.2-31.63,7.2c-9.37,0-16.96-1.23-22.76-3.68c-5.81-2.45-10.38-5.58-13.73-9.37c-3.8-4.24-6.48-9.82-8.04-16.74
		c-1.56-6.92-2.34-15.85-2.34-26.78v-84.7c0-10.04-1.51-17.46-4.52-22.26c-3.01-4.8-8.65-7.2-16.91-7.2v-7.03
		c7.14,0.67,14.06,1,20.76,1c9.37,0,18.13-0.39,26.28-1.17c8.15-0.78,15.68-1.95,22.6-3.52v138.6c0,5.58,0.5,10.49,1.51,14.73
		c1,4.24,2.96,7.53,5.86,9.88c2.9,2.34,7.14,3.52,12.72,3.52c8.92,0,16.57-3.74,22.93-11.22c6.36-7.47,9.54-16.68,9.54-27.62v-87.71
		c0-10.04-1.51-17.46-4.52-22.26c-3.01-4.8-8.65-7.2-16.91-7.2v-7.03c7.14,0.67,14.06,1,20.76,1c9.37,0,18.13-0.39,26.28-1.17
		C993.57,254.6,1001.1,253.43,1008.02,251.86z"/>
				<path d="M1088.36,430.97c-14.96,0-25.78-3.9-32.47-11.72c-6.7-7.81-10.04-17.29-10.04-28.46c0-9.59,2.18-17.41,6.53-23.43
		c4.35-6.03,9.98-10.99,16.91-14.9c6.91-3.9,14.23-7.14,21.93-9.71c7.7-2.56,15.07-5.13,22.09-7.7c7.03-2.56,12.72-5.52,17.07-8.87
		c4.35-3.35,6.53-7.58,6.53-12.72v-26.11c0-5.8-0.95-10.99-2.84-15.57c-1.9-4.57-4.8-8.09-8.7-10.54
		c-3.91-2.45-8.99-3.68-15.23-3.68c-4.47,0-8.93,0.62-13.39,1.84c-4.47,1.23-8.15,3.3-11.05,6.19c6.25,2.23,11.1,5.64,14.56,10.21
		c3.46,4.58,5.19,9.77,5.19,15.57c0,7.59-2.62,13.62-7.86,18.08c-5.25,4.47-11.44,6.7-18.58,6.7c-8.04,0-14.12-2.51-18.25-7.53
		c-4.13-5.02-6.19-11.1-6.19-18.25c0-6.47,1.62-11.83,4.85-16.07c3.23-4.24,7.75-8.26,13.56-12.05c6.24-3.57,13.78-6.36,22.6-8.37
		c8.82-2.01,18.36-3.01,28.62-3.01c10.26,0,19.53,1.06,27.79,3.18c8.26,2.12,15.17,5.97,20.76,11.55
		c5.13,5.14,8.48,11.44,10.04,18.91c1.56,7.48,2.34,16.91,2.34,28.29v91.06c0,5.36,0.55,9.15,1.67,11.38
		c1.12,2.23,3.01,3.35,5.69,3.35c2.23,0,4.35-0.55,6.36-1.67c2.01-1.11,3.9-2.45,5.69-4.02l3.35,5.69
		c-4.69,4.02-10.1,7.09-16.23,9.21c-6.14,2.12-13.01,3.18-20.59,3.18c-13.39,0-22.26-2.73-26.61-8.2
		c-4.35-5.47-6.64-11.77-6.86-18.91c-5.58,9.15-12.44,15.96-20.59,20.42C1108.84,428.73,1099.29,430.97,1088.36,430.97z
		 M1114.14,409.54c4.24,0,8.2-1,11.89-3.01c3.68-2.01,7.31-5.58,10.88-10.71v-68.63c-2.68,4.47-6.42,8.2-11.21,11.22
		c-4.8,3.01-9.71,6.25-14.73,9.71c-5.02,3.46-9.21,7.87-12.55,13.22c-3.35,5.36-5.02,12.5-5.02,21.42c0,9.6,2.01,16.46,6.03,20.59
		C1103.43,407.48,1108.33,409.54,1114.14,409.54z"/>
				<path d="M1304.62,250.86c8.7,0,16.68,0.95,23.94,2.84c7.25,1.9,13.22,4.3,17.91,7.2c5.8,3.57,10.32,7.98,13.56,13.22
		c3.23,5.25,4.86,11.33,4.86,18.25c0,7.81-2.46,14.23-7.37,19.25c-4.91,5.02-11.27,7.53-19.08,7.53c-7.82,0-14.06-2.23-18.75-6.7
		c-4.69-4.46-7.03-10.49-7.03-18.08c0-7.14,2.23-13.11,6.7-17.91c4.46-4.8,9.59-7.98,15.4-9.54c-1.79-2.23-4.47-4.13-8.03-5.69
		c-3.57-1.56-7.59-2.34-12.05-2.34c-6.92,0-13,2.01-18.25,6.03c-5.25,4.02-9.66,9.6-13.22,16.74c-3.57,7.15-6.31,15.52-8.2,25.11
		c-1.9,9.6-2.84,20.09-2.84,31.47c0,17.19,2.18,30.69,6.53,40.51c4.35,9.82,9.93,16.74,16.74,20.76c6.8,4.02,13.89,6.03,21.26,6.03
		c6.25,0,13.39-1.73,21.43-5.19c8.04-3.46,15.51-10.76,22.43-21.93l5.69,2.01c-2.46,8.26-6.48,16.52-12.05,24.77
		c-5.58,8.26-12.84,15.01-21.76,20.25c-8.93,5.24-19.87,7.87-32.81,7.87c-14.51,0-27.62-3.18-39.34-9.54
		c-11.72-6.36-21.09-16.18-28.12-29.46c-7.03-13.28-10.54-30.41-10.54-51.39c0-20.09,3.63-36.99,10.88-50.72
		c7.25-13.73,17.13-24.05,29.63-30.97C1274.6,254.32,1288.77,250.86,1304.62,250.86z"/>
				<polyline points="126.95,428.07 115.91,428.07 0.22,428.07" />
			</g>
		</svg>
	);
};

LogoPrimary.propTypes = {
	clssName: PropTypes.string,
};

LogoPrimary.defaultProps = {
	clssName: "",
};

export default LogoPrimary;
